import { statAssets } from '../constants/assets'
import type { StatCard } from '../types'

/** Rendered in the gradient card that leads the row. */
export const highlightStat: StatCard = {
  id: 'total-bookings',
  label: 'Total Bookings',
  value: '1,248',
  icon: statAssets.bookings,
  chipSize: 27,
  glyphSize: 16,
  flipped: true,
  glyphInset: '7.89% 3.44%',
  caption: '+18.5% from last month',
  showTrend: true,
}

export const stats: StatCard[] = [
  {
    id: 'todays-trips',
    label: "Today's Trips",
    value: '32',
    icon: statAssets.tripsToday,
    chipSize: 30,
    glyphSize: 20,
    caption: '+12.3% from yesterday',
    showTrend: true,
  },
  {
    id: 'upcoming-trips',
    label: 'Upcoming Trips',
    value: '87',
    icon: 'clock',
    chipSize: 30,
    glyphSize: 24,
    caption: '+15.7% from last week',
    showTrend: true,
  },
  {
    id: 'total-revenue',
    label: 'Total Revenue',
    value: '1,248',
    icon: statAssets.revenue,
    chipSize: 28,
    glyphSize: 21,
    caption: '+22.8% from last month',
    showTrend: true,
  },
  {
    id: 'active-vehicles',
    label: 'Active Vehicles',
    value: '35',
    icon: statAssets.vehicles,
    chipSize: 31,
    glyphSize: 19,
    caption: 'Out of 42 vehicles',
    showTrend: false,
  },
]
